import Vue from "vue";
import store from "@/store";
import router from "@/router/winterGame";
import WinterGame from "@views/WinterGame/index.vue";
import "vant/lib/index.less";
import "../assets/style/animate.min.css";
import Vconsole from "vconsole";
if (
  process.env.VUE_APP_ENV === "test" ||
  process.env.VUE_APP_ENV === "development" ||
  process.env.VUE_APP_ENV === "pre"
) {
  //   let vConsole = new Vconsole();
  //   Vue.use(vConsole);
}
Vue.filter("formatNumberFilter", (e) => {
  return String(e).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
});

// let vConsole = new Vconsole();
// Vue.use(vConsole);

sessionStorage.removeItem("isReload");
import {
  DatetimePicker,
  Popup,
  Tab,
  Tabs,
  Swipe,
  SwipeItem,
  Icon,
  Calendar,
  List,
  Loading,
  Dialog,
  DropdownMenu,
  DropdownItem,
  Popover
} from "vant";

Vue.config.productionTip = false;
Vue.use(DatetimePicker);
Vue.use(Popup);
Vue.use(Tab);
Vue.use(Tabs);
Vue.use(Swipe);
Vue.use(SwipeItem);
Vue.use(Icon);
Vue.use(Calendar);
Vue.use(List);
Vue.use(Loading);
Vue.use(Dialog);
Vue.use(DropdownMenu);
Vue.use(DropdownItem);
Vue.use(Popover);

new Vue({
  router,
  store,
  render: (h) => h(WinterGame),
}).$mount("#app");
